export default (el, selector) ->
  el and el.matches and el.matches selector